import React from 'react';
import { Radio, Space, Typography } from 'antd';

const { Text } = Typography;

// ══════════════════════════════════════════════
//  Mock 角色（原型演示用）
//  企业角色：仅可见本企业的编译链 / 编译任务；不可访问 SDK版本管理
//  平台角色：可查看全平台编译链 / 编译任务；可管理 SDK版本（SDK服务）
//  TODO: 联调时替换为登录态返回的角色
// ══════════════════════════════════════════════

const STORAGE_KEY = 'compile_mock_role';

// 企业角色的「本企业」（mock）
export const MY_ENTERPRISE = '东莞康林物联网有限公司';

// 平台角色可见的全部企业（mock）
export const MOCK_ENTERPRISES = [
    '东莞康林物联网有限公司',
    '深圳智联科技有限公司',
];

export const getCompileRole = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) || 'enterprise';
    } catch (e) {
        return 'enterprise';
    }
};

export const setCompileRole = (role) => {
    try {
        localStorage.setItem(STORAGE_KEY, role);
    } catch (e) {
        // 忽略存储异常（隐私模式等），仅本次会话生效
    }
};

/**
 * 角色切换器（原型演示用）
 * 三个页面（编译链管理 / 编译任务 / SDK版本管理）共用同一角色，切换后保持一致
 */
const CompileRoleSwitcher = ({ role, onChange }) => (
    <Space>
        <Text type="secondary">Mock角色：</Text>
        <Radio.Group
            value={role}
            onChange={(e) => onChange(e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="small"
        >
            <Radio.Button value="enterprise">企业角色</Radio.Button>
            <Radio.Button value="platform">平台角色</Radio.Button>
        </Radio.Group>
    </Space>
);

export default CompileRoleSwitcher;
